<template>
<!--   <div> -->
     <v-dialog v-model="dialogshowfile" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card style="background-color: rgba(0, 0, 0, 0.9);" class="hidden-sm-and-down">
          <v-toolbar dark style="background-color: #1b232d;">
            <v-flex xl1 lg1 md1 sm1 style="text-align: right; padding-right: 2vw;">
              <v-avatar class="user-photo" style="cursor: pointer;" @click="openPictureProfile(DetailFile.path_pic, DetailFile.type)">
                <img v-if="DetailFile.path_pic" :src="DetailFile.path_pic" class="alligator-turtle">
                <img v-else-if="DetailFile.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                <img v-else-if="DetailFile.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
              </v-avatar>
            </v-flex>
          <v-flex xl6 lg6 md6 sm6>
            <!-- {{DetailFile}} -->
            <b style="font-size: 14px;"> {{DetailFile.file_name}}</b>
            <p style="font-size: 12px; margin-bottom: 0px;"> {{$t('Dialog.showImage.by')}} {{DetailFile.nickname}} &nbsp;&nbsp;| &nbsp;{{date(DetailFile.timestamp)}}
              <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{time(DetailFile.timestamp)}}
            </p>
          </v-flex>
          <v-flex xl4 lg4 md4 sm4 style="text-align: right;">
            <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic(DetailFile.file_name)">
              <v-icon>file_download</v-icon>&nbsp; {{$t('AnswerQuestion.download')}}
            </v-btn>
            <v-btn depressed small class="btncancel CSChatThai" @click="sendonebox(DetailFile.tokenmessage)">
              <v-icon>cloud_upload</v-icon> &nbsp; {{$t('AnswerQuestion.sendOnebox')}}
            </v-btn>
          </v-flex>
         <v-flex xl1 lg1 md1 sm1 style="text-align: right;">
          <v-btn icon @click="closeDialogShowFile">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
          </v-flex>

          </v-toolbar>
          <div style="background: none;">
            <iframe v-if="DetailFile.typeofmessage !== 'video'" :src="DetailFile.message" style="width:100%; height:100%;justify-content: center;height: calc(100vh - 64px);" frameborder="0"></iframe>
            <!-- <div v-else style="width:100%; justify-content: center; height: calc(100vh - 64px);">
              <vplayer
                :playerOptions="{
                  type: 'application/x-mpegURL',
                  src: DetailFile.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: DetailFile.thumbnail,
                  controls: 'progress, current, durration, volume',
                  crossOrigin: false
                }"
                @onplay="play"
              />
            </div> -->
          </div>
        </v-card>


<div class="hidden-md-and-up">

      <div id="headcaption">
        <v-container>
          <v-layout row wrap>
            <v-flex md2 sm2 xs2 style="text-align: right; padding-right: 2vw;">
              <v-avatar class="user-photo" style="cursor: pointer;" @click="openPictureProfile(DetailFile.path_pic, DetailFile.type)">
                <img v-if="DetailFile.path_pic" :src="DetailFile.path_pic" class="alligator-turtle">
                <img v-else-if="DetailFile.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                <img v-else-if="DetailFile.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
              </v-avatar>
            </v-flex>
            <v-flex xs9 md9 sm9>
              <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{DetailFile.file_name}}</p>
              <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> {{$t('Dialog.showImage.by')}} {{DetailFile.nickname}}
              </p>
              <p style="font-size: 12px;">{{$t('Dialog.showImage.date')}} {{date(DetailFile.timestamp)}} &nbsp;<v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{time(DetailFile.timestamp)}}
              </p>
            </v-flex>
            <v-flex xs1 md1 sm1>
              <v-btn icon @click="closeDialogShowFile">
                <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
              <v-btn depressed small  class="btnallow text-transform" @click="loadpic(DetailFile.file_name)" >
                <v-icon>file_download</v-icon>&nbsp;
                  {{$t('AnswerQuestion.download')}}
                </v-btn>
                <v-btn depressed small class="btncancel text-transform" @click="sendonebox(DetailFile.tokenmessage)">
                  <v-icon>cloud_upload</v-icon> &nbsp;
                    {{$t('AnswerQuestion.sendOnebox')}}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
      </div>
      <div style="overflow-y: scroll; height: 90%;" v-if="extension(DetailFile.message) == 'pdf'">
        <pdf
          v-for="i in numPages"
          :key="i"
          :page="i"
          :src="DetailFile.message"
          ref="myPdfComponent"
          >
        </pdf>
      </div>
          <div style="background: none;" v-else>
            <iframe v-if="DetailFile.typeofmessage !== 'video'" :src="DetailFile.message" style="width:100%; height:100%;justify-content: center;height: calc(100vh - 64px);" frameborder="0"></iframe>
            <div v-else style="width:100%; justify-content: center; height: calc(100vh - 64px);">
              <vplayer
                :playerOptions="{
                  type: 'application/x-mpegURL',
                  src: DetailFile.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: DetailFile.thumbnail,
                  controls: 'progress, current, durration, volume',
                  crossOrigin: false
                }"
                @onplay="play"
              />
            </div>
          </div>
        <!-- </v-card> -->

        </div>
        <ShowImageProfileDialog :dialogshowimage_profile="dialogshowimage_profile" :pathpicture="pathpicture" :typepathpicture="typepathpicture" @closeDialogShowImage_Profile="closeDialogShowImage_Profile"/>
        <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>

      </v-dialog>
</template>

<script>
import SaveOnebox from '@/components/chat/dialog/saveonebox/SaveoneboxDialog'
import ShowImageProfileDialog from '@/components/chat/dialog/ShowImage_ProfileDialog'
import { sync } from 'vuex-pathify'
import {Momenttime, Decode} from '@/services'
import { vplayer } from 'vue-hls-player'
import pdf from 'vue-pdf'

export default {
  props: {dialogshowfile: false, DetailFile: {}},
  data: () => ({
    token: '',
    dialogshowimage_profile: false,
    pathpicture: '',
    typepathpicture: '',
    dialogSaveOnebox: false,
    tokenmessage_savebox: '',
    numPages: '',
    filepdf: ''
  }),
  computed: {
    ...sync('*')
  },
  watch: {
    // filepdf () {
    //   // console.log(this.filepdf)
    //   this.src = pdf.createLoadingTask(this.filepdf)
    //   // console.log(this.src)
    //   this.src.promise.then(pdf => {
    //     // console.log(pdf)
    //     this.numPages = pdf.numPages
    //     // console.log(this.numPages)
    //   })
    // },
    dialogshowfile(){
        if(this.dialogshowfile == true){
          // console.log(this.DetailFile)
          if(this.extension(this.DetailFile.message) == 'pdf'){
          this.filepdf = this.DetailFile.message
          // console.log(this.filepdf)
    }
        }
    // DetailFile(){
    //   console.log(this.DetailFile)
    // }
    },
    filepdf () {
      // console.log(this.filepdf)
      this.src = pdf.createLoadingTask(this.filepdf)
      // console.log(this.src)
      this.src.promise.then(pdf => {
        // console.log(pdf)
        this.numPages = pdf.numPages
        // console.log(this.numPages)
      })
    },
  },
  components: {
    pdf,
    ShowImageProfileDialog,
    SaveOnebox,
    vplayer
  },
  methods: {
    // passwordPdf (updatePassword, reason) {
    //   console.log(reason)
    //   updatePassword(prompt('password is "test"'));
    // },
    // errorPdf (err) {
    //   console.log(err)
    // },
    play (e) {
      // console.log(e)
    },
    openPictureProfile (picture, type) {
      this.pathpicture = picture
      this.typepathpicture = type
      this.dialogshowimage_profile = true
    },
    closeDialogShowImage_Profile (value) {
      this.dialogshowimage_profile = value
    },
    loadpic(filenameSend) {
      // console.log(this.DetailFile)
      if (this.DetailFile.typeofmessage === 'video') {
        this.axios.get(this.DetailFile.original_file, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filenameSend)
          document.body.appendChild(link)
          link.click()
        })
      } else {
        this.axios.get(this.DetailFile.message, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filenameSend)
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    sendonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = value
    },
    closeDialogShowFile () {
      this.$emit('closeDialogShowFile', false)
    },
    date (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    extension (path) {
      if(path !== undefined && path.includes('.') == true){
          var fullname_path = path.split('.')[path.split('.').length - 1].toLowerCase()
        if(fullname_path.includes(' ')){
          var path_space = fullname_path.split(' ')
          var extension = path_space[0]
        }else{
          var extension = fullname_path
        }
        // console.log( 'path' , path)
        // var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm','xlsx']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
        var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
        var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
        if (pdf.includes(extension)) {
          return 'pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (media.includes(extension)) {
          return 'media'
        } else if (audio.includes(extension)) {
          return 'audio'
        } else {
          return 'fas fa-file-alt'
        }
      } else {
          return 'fas fa-file-alt'
        }
    },
    // this.dateSend = Momenttime.momentdatethai(timestamp)
    //   // this.timeSend = Momenttime.momenttimethai(timestamp)
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']

    if(this.extension(this.DetailFile.message) == 'pdf'){
      this.filepdf = this.DetailFile.message
      // console.log(this.filepdf)
    }
    // this.filepdf =
  }
}
</script>
<style scoped>
>>>.vplayer video {
  width: 100% !important;
  height: calc(100vh - 64px) !important;
}
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
#headcaption {
  /*margin: auto;
  display: block;
  text-align: left;
  color: white;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;*/
  margin: auto;
  display: block;
  text-align: left;
  color: #fff;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/ShowPDFDialog.vue